<template>
  <div class="no-data-segment flex-center text-center bc-white border-radius-8">
    <div class="flex flex-col items-center">
      <img :src="src" :style="`width: ${width}px;max-width: 259px;`" alt="" />
      <div class="description" :class="`font-size-${fontSize}`" v-html="title"></div>
      <div class="no-data-segment-bottom" v-if="$slots.default">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import placeHolderEmpty from '@Assets/images/empty2.png'
export default {
  props: {
    title: {
      type: String,
      default: '暂无数据'
    },
    src: {
      type: String,
      default: placeHolderEmpty
    },
    width: {
      type: Number,
      default: 120
    },
    fontSize: {
      type: Number,
      default: 14
    }
  }
}
</script>

<style scope lang="less">
.no-data-segment {
  .description {
    color: #18191c;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
    margin-top: 8px;
  }
  &-bottom {
    margin-top: 10px;
  }
}
</style>
